import { BanIcon, LogOutIcon } from 'lucide-react';

import { useSession } from '@/components/auth/user-provider';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Shown when the signed-in account exists but has been deactivated by an admin.
 */
export function AccessBlockedPage() {
  const { session, signOut } = useSession();
  const name = session.status === 'signedIn' ? session.user.name : 'there';

  return (
    <div className="flex flex-1 items-center justify-center p-4 md:p-8">
      <Card className="border-border/80 w-full max-w-lg shadow-sm">
        <CardHeader className="items-center space-y-3 text-center">
          <span className="bg-muted text-foreground ring-border flex size-14 items-center justify-center rounded-2xl ring-1">
            <BanIcon className="size-7" aria-hidden />
          </span>
          <CardTitle className="text-xl">Account deactivated</CardTitle>
          <CardDescription className="text-base">
            Hi {name}. Your School Attendance account has been deactivated. You cannot open app
            screens until an administrator reactivates it.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <p className="text-muted-foreground text-center text-sm">
            Contact your school administrator if you believe this is a mistake.
          </p>
          <Button variant="default" onClick={() => signOut()}>
            <LogOutIcon /> Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
